import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import WarningIcon from '@mui/icons-material/Warning';
import { Grid, Paper, styled } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import axios from 'axios';
import * as React from 'react';
import { memo, useEffect, useState } from 'react';
import apiConfig from 'src/api/APIConfig';
import { useAppDispatch } from 'src/store/hooks';
// import { setSnackbarMessage } from 'src/store/snackbarMessage';
//import { useFieldTranslation } from '../../fields/useFieldTranslation';
import { setMessage } from 'src/store/Message';
import './MilestoneTracking.scss';

const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary
}));

const Progress: React.FunctionComponent<any> = ({ selectedMilestone, studyId, siteId }) => {
  const [gridRows, setGridRows] = useState<any>([]);
  const [completedPercentage, setCompletedPercentage] = useState('');
  const [inProgressPercentage, setInProgressPercentage] = useState('');
  const [overduePercentage, setOveduePercentage] = useState('');
  const [otherPercentage, setOtherPercentage] = useState('');
  const [overdue, setOverdue] = useState();
  const [iterableArr, setIterableArr] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useAppDispatch();
  const majorMileStone = selectedMilestone.major_milestone;
  const selMinorMileStone = selectedMilestone.minor_milestone;
  const [totalOthermileStone, setTotalOtherMileStone] = useState<any>();
  const getData = async () => {
    try {
      setIsLoading(true);
      const options = {
        site_id: siteId,
        study_id: studyId,
        pathVariables: {
          major_milestone: majorMileStone
        }
      };
      //const response: any = await sendRequest('get_milestone_progress', options);
      const progressData = await axios.get(
        `${apiConfig.appConfig.apictms}/site/milestone/progress/${siteId}/${studyId}/select?majorMilestone=${majorMileStone}`
      );
      const response = progressData.data;
      setGridRows(response);
      const totalCount = response.total_completed + response.total_in_progress + response.total_overdue;
      setCompletedPercentage(Math.round((response.total_completed / response.total_minor_milestones) * 100).toString());
      //setCompletedPercentage(response.setCompletedPercentage)
      const value = response.total_in_progress;
      setInProgressPercentage(
        Math.round((response.total_in_progress / response.total_minor_milestones) * 100).toString()
      );
      setOveduePercentage(Math.round((response.total_overdue / response.total_minor_milestones) * 100).toString());
      //const totalOthMileStone=response.total_minor_milestones-totalCount
      setTotalOtherMileStone(response.total_minor_milestones - totalCount);
      setOtherPercentage(
        Math.round(((response.total_minor_milestones - totalCount) / response.total_minor_milestones) * 100).toString()
      );
      let mileArray: any[] = [];
      if (response.total_completed >= response.total_in_progress && response.total_completed >= response.total_overdue)
        mileArray = response.completed_milestones;
      else if (
        response.total_in_progress >= response.total_completed &&
        response.total_in_progress >= response.total_overdue
      )
        mileArray = response.in_progress_milestones;
      else mileArray = response.overdue_milestones;

      const newArray: any[] = [];
      mileArray.map((row: any, index: number) => {
        const completed: any = response.completed_milestones[index] ? response.completed_milestones[index] : '';
        const in_progress: any = response.in_progress_milestones[index] ? response.in_progress_milestones[index] : '';
        const overdue: any = response.overdue_milestones[index] ? response.overdue_milestones[index] : '';
        newArray.push({ completed: completed, in_progress: in_progress, overdue: overdue });
      });
      setIterableArr(newArray);
      setIsLoading(false);
    } catch (error: any) {
      // store.dispatch(setSnackbarMessage('Request Failed', 'error'));
      dispatch(setMessage({ msgDetails: 'Error loading details', severity: 'error' }));
      if (error.response.status === 403) {
        dispatch(setMessage({ msgDetails: 'Error 403 Restricted User permission', severity: 'error' }));
      } else if (error.response.status === 401) {
        dispatch(setMessage({ msgDetails: 'Error 401 Unauthorized access', severity: 'error' }));
      }
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <div className="progress-page">
      <Grid container className="card">
        <Grid md={12}>
          <Grid container>
            <Grid md={3}>
              <div className="info green">
                <div className="icon">
                  <CheckCircleIcon />
                </div>
                <div className="description">
                  <h5>Completed</h5>
                  <div className="count">
                    <strong>{gridRows.total_completed}</strong>/{gridRows.total_minor_milestones}
                  </div>
                </div>
              </div>
            </Grid>
            <Grid md={3}>
              <div className="info blue">
                <div className="icon">
                  <PendingActionsIcon />
                </div>
                <div className="description">
                  <h5>In Progress</h5>
                  <div className="count">
                    <strong>{gridRows.total_in_progress}</strong>/ {gridRows.total_minor_milestones}
                  </div>
                </div>
              </div>
            </Grid>
            <Grid md={3}>
              <div className="info orange">
                <div className="icon">
                  <WarningIcon />
                </div>
                <div className="description">
                  <h5>Overdue</h5>
                  <div className="count">
                    <strong>{gridRows.total_overdue}</strong>/ {gridRows.total_minor_milestones}
                  </div>
                </div>
              </div>
            </Grid>
            <Grid md={3}>
              <div className="info yellow">
                <div className="icon">
                  <WarningIcon />
                </div>
                <div className="description">
                  <h5>Other</h5>
                  <div className="count">
                    <strong>{totalOthermileStone}</strong>/ {gridRows.total_minor_milestones}
                  </div>
                </div>
              </div>
            </Grid>
            {/* <MultiColorBar readings={readings} /> */}
          </Grid>

          <Grid container className="progress-status">
            <Grid md={12}>
              <h3>
                <strong>{completedPercentage}%</strong> Site Live / Ready Completeness
              </h3>
              <div style={{ display: 'flex', borderRadius: '0 99px 99px 0', overflow: 'hidden' }} className="bars">
                <div
                  style={{
                    width: `${completedPercentage}%`,
                    backgroundColor: '#6ab04c',
                    height: '15px',
                    borderRadius: '99px 0 0 99px'
                  }}
                  className="progress-complete"
                ></div>
                <div
                  style={{ width: `${inProgressPercentage}%`, backgroundColor: '#3F51B5', height: '15px' }}
                  className="progress-inProgress"
                ></div>
                <div
                  style={{
                    width: `${overduePercentage}%`,
                    backgroundColor: '#eb4d4b',
                    height: '15px'
                  }}
                  className="progress-overdue"
                ></div>
                <div
                  style={{
                    width: `${otherPercentage}%`,
                    backgroundColor: '#ffca45',
                    height: '15px',
                    borderRadius: '0 99px 99px 0'
                  }}
                  className="progress-other"
                ></div>
              </div>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Grid>
        <Grid md={12}>
          <TableContainer component={Paper} className="progress-table">
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>
                    <b>Completed</b>
                  </TableCell>
                  <TableCell>
                    <b>In Progress</b>
                  </TableCell>
                  <TableCell>
                    <b>Overdue</b>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {iterableArr.map((row: any, index: number) => (
                  <TableRow key={index}>
                    <TableCell
                      className={row.completed == selectedMilestone.minor_milestone ? 'minorMilstoneHelight' : ' '}
                    >
                      {row.completed}
                    </TableCell>
                    <TableCell
                      className={row.in_progress == selectedMilestone.minor_milestone ? 'minorMilstoneHelight' : ' '}
                    >
                      {row.in_progress}
                    </TableCell>
                    <TableCell
                      className={row.overdue == selectedMilestone.minor_milestone ? 'minorMilstoneHelight' : ' '}
                    >
                      {row.overdue}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
    </div>
  );
};

export default memo(Progress);
